<template>
  <div class="home_bg">
    <div style="color:#666666;font-size: 15px;margin-bottom: 20px;">
      <span>当前所在位置：月度城与全国同比对比>{{name}}</span>
    </div>
    <div>
      <el-form inline>
         <el-form-item label="口径选择">
          <el-select v-model="bores_id" @change="selectProvince">
            <el-option v-for="item in bores" :label="item.title" :value="item.id" :key="item.id">

            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
        <el-date-picker
          v-model="cr_at"
          type="year"
          placeholder="选择开始年份" format="yyyy" value-format="yyyy"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>---</el-form-item>
        <el-form-item>
        <el-date-picker
          v-model="end_time"
          type="year"
          placeholder="选择结束年份" format="yyyy" value-format="yyyy"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button class="btn-info" @click="timeChange">
          按年份查询
        </el-button>
      </el-form-item>
        <!-- <el-form-item label="模块选择" >
          <el-select v-model="modul_id" @change="selectProvince2">
            <el-option v-for="item in modul" :label="item.title" :value="item.id" :key="item.id">

            </el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
    </div>
    <div class="echarts">
      <div id="myChart" :style="{ width: '100%', height: '778px' }"></div>
    </div>
  </div>
</template>

<script>
import { getbores,getcitys,getmoduls,gettargets} from "../../api/ranking";
import { getmonthcitytongbiall} from "../../api/reading";

export default {
  name: "Echarts",
  data() {
    return {
        pickerOptions:{
        //disabled为函数，返回值为布尔值，
          disabledDate: (time) => {
            let minYear = new Date().getFullYear() - 10          
            // return time> Date.now() || time.getTime() < new Date(JSON.stringify(minYear))
            return time> Date.now() 

          }

      },
      cr_at:this.setTime1()+"",
      end_time:this.setTime2()+"",
      user: localStorage.getItem("username"),
      echarts:'',
      allData:'',
      allData2:[],
      //x轴数据
      year_data:[],
      //折线
      x_zhexian:[],
      //柱状图x_zhu:[]
      x_zhu:[],
      //名称
      name:'房地产开发投资额',
      //口径
      bores:[],
      //口径id
      bores_id:'',
      //城市
      city:[],
      //城市id
      city_id:'1',
      //模块
      modul:[],
      //模块id
      modul_id:'',
      //指标id
      target_id: this.$route.query.target_id==undefined||this.$route.query.target_id==""?"250": this.$route.query.target_id,
      //指标
      target:[]
    };
  },
  // 注册组件
  components: {},
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    setTime1() {
      const nowD = new Date();
      return nowD.getFullYear()-10
    },
    setTime2() {
      const nowD = new Date();
      return nowD.getFullYear()
    },
     dateFormat(fmt, date) {
        let ret = "";
        date = new Date(date);
        const opt = {
          'Y+': date.getFullYear().toString(), // 年
          'm+': (date.getMonth() + 1).toString(), // 月
          'd+': date.getDate().toString(), // 日
          'H+': date.getHours().toString(), // 时
          'M+': date.getMinutes().toString(), // 分
          'S+': date.getSeconds().toString() // 秒
          // 有其他格式化字符需求可以继续添加，必须转化成字符串
        }
        for (let k in opt) {
          ret = new RegExp('(' + k + ')').exec(fmt)
          if (ret) {
            fmt = fmt.replace(
              ret[1],
              ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
            )
          }
        }
        return fmt
      },
      timeChange(){
        this.year_data=[],
        this.x_zhu=[],
        this.x_zhexian=[]
        this.getData()
      },
    selectProvince(val){
      this.year_data=[],
      this.x_zhu=[],
      this.x_zhexian=[]
      this.getData()
    },
    selectProvince1(val){
      this.year_data=[],
      this.x_zhu=[],
      this.x_zhexian=[]
      this.getData()
    },
    selectProvince2(val){
      this.year_data=[],
      this.x_zhu=[],
      this.x_zhexian=[]
      this.getData()
    },
    selectProvince3(val){
      this.year_data=[],
      this.x_zhu=[],
      this.x_zhexian=[]
      this.getData()
    },
    gettarget(){
      gettargets().then(res=>{
        if (res.errno === 0) {
          for(var i in res.data){
            var obj={
              title:res.data[i],
              id:i
            }
            this.target.push(obj)
          }
          this.target.push({title:"全部",id:''})
          } else if (res.errno === 401) {
            this.$store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          } else {
            this.$message.error(res.data)
          }
      })
    },
    getmodul(){
      getmoduls().then(res=>{
        if (res.errno === 0) {
          for(var i in res.data){
            var obj={
              title:res.data[i],
              id:i
            }
            this.modul.push(obj)
          }
          this.modul.push({title:"全部",id:''})
          } else if (res.errno === 401) {
            this.$store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          } else {
            this.$message.error(res.data)
          }
      })
    },
    getcity(){
      getcitys().then(res=>{
        if (res.errno === 0) {
          for(var i in res.data){
            var obj={
              title:res.data[i],
              id:i
            }
            this.city.push(obj)
          }
          this.city.push({title:"全部",id:''})
          } else if (res.errno === 401) {
            this.$store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          } else {
            this.$message.error(res.data)
          }
      })
    },
    getbore(){
      getbores().then(res=>{
        if (res.errno === 0) {
          this.bores.push({title:"全部",id:''})
          for(var i in res.data){
            var obj={
              title:res.data[i],
              id:i
            }
            this.bores.push(obj)
          }
          
          } else if (res.errno === 401) {
            this.$store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          } else {
            this.$message.error(res.data)
          }
      })
    },
    
    getData(){
      let params={
        token: localStorage.getItem('token'),
        target_id:this.target_id,
        bore_id:this.bores_id,
        city_id:this.city_id,
        module_id:this.modul_id,
        years:this.cr_at==''||this.cr_at==undefined?"":this.dateFormat('YYYY',this.cr_at),
        endyears:this.cr_at==''||this.cr_at==undefined?"":this.dateFormat('YYYY',this.end_time),
      }
      getmonthcitytongbiall(params).then(res=>{
        if (res.errno === 0) {
          this.allData=res.data.list
          this.name=res.data.target.name

          for(var i in this.allData){
            var obj={
              time:i,
              citytongbi:this.allData[i].citytongbi,
              tongbi:this.allData[i].tongbi
            }
            this.allData2.push(obj)
          }
          let hashMap1=this.allData2.sort((a,b)=>{
            return a["time"].slice(0,4).localeCompare(b["time"].slice(0,4))
          })
          for(var i in hashMap1){
           this.year_data.push( hashMap1[i]["time"])
           this.x_zhu.push(hashMap1[i]["citytongbi"])
           this.x_zhexian.push(hashMap1[i]["tongbi"])
          }

          // for(var i in this.allData){
          //   this.year_data.push(i)
          //   this.x_zhu.push(this.allData[i].tongbi)
          //   this.x_zhexian.push(this.allData[i].citytongbi)
          // }
        //   if(this.cr_at!=''||this.cr_at!=undefined){
        //       this.echarts.setOption({
        //           series:[{
        //               barWidth: 20,
        //           }]
        //       })
        //   }
          this.echarts.setOption({
            title:{text:this.name},
            xAxis:[{
              data:this.year_data
            }],
            series:[{
              data:this.x_zhu
            },    //折线图
          {
            zlevel: 10,
            type: "line",
            data: this.x_zhexian,
            itemStyle: {
              normal: {
                lineStyle: {
                //   color: "rgb(255 107 63)",
                },
                // label:{
                //   show:true,
                //   formatter:"{c}%"
                // }
              },
            },
          },]

          })
          } else if (res.errno === 401) {
            this.$store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          } else {
            this.$message.error(res.data)
          }
      })
    },
    drawLine3() {
      // 基于准备好的dom，初始化echarts实例
      this.echarts = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      this.echarts.setOption({
        title: { text: "房地产开发投资额" },
        tooltip:{
                trigger: 'axis',
                // formatter:function(param){
                  
                //   var name1=param[0].data
                //   var name2=param[1].data
                //     return param[0].axisValue+'<br/>'+'同比：'+name1 +'%'+ '<br/>' + '城市同比：'+name2+"%"
                // }
            },
            legend: {
                data: [ '全国同比','城市同比']
            },
            grid: {
                // top: '10%',
                left: '2%',
                right: '2%',
                bottom: '5%',
                containLabel: true
            },
        xAxis: [
          {
            type: "category",
            axisTick: {
              show: true,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#e3e3e3",
              },
            },
            axisLabel: {
              inside: false,
              rotate: 90,
              interval: 0,
              // formatter:function(value)
              //   {
              //       return value.split("").join("\n");
              //   },
                textStyle: {
                color: "#999",
                // fontWeight: "normal",
                // fontSize: "12",
              },
            },
            splitLine: { show: false }, // 去除网格线
            data: []
          },

          {
            type: "category",
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: { show: false },
            splitArea: { show: false },
            splitLine: { show: false },
            data: []
          },
        ],


        yAxis: [
          
          {
            name:'百分比',
            type: "value",
       
            axisLabel: {
              formatter: "{value}%",
              textStyle: {
                color: "#999",
              },
            },

            axisTick: {
              show: true,
            },

            axisLine: {
              lineStyle: {
                color: "transparent", // 坐标轴线颜色
              },
            },
            splitLine: { show: true }, // 去除网格线
          },
        ],
        dataZoom: [
            {
                show: true,
                start: 80,
                end: 100
            },
            // {
            //     type: 'inside',
            //     start: 80,
            //     end: 100
            // },
            // {
            //     show: true,
            //     yAxisIndex: 0,
            //     filterMode: 'empty',
            //     width: 10,
            //     height: '80%',
            //     showDataShadow: false,
            //     left: '93%'
            // }
        ],
        series: [
         {
             name:'全国同比',
            // zlevel: 10,
            type: "line",
            data: [],
            smooth: true,

            itemStyle: {
              normal: {
                  color:"rgb(28 130 224)",
                lineStyle: {
                  color: ["rgb(28 130 224)"],
                },
              },
            },
          },
          //折线图
          {
            name:'城市同比',
            // zlevel: 10,
            type: "line",
            data: [],
            smooth: true,
            itemStyle: {
              normal: {
                  color:"rgb(255,107,63)",
                lineStyle: {
                  color: "rgb(255,107,63)",
                },
              },
            },
          },
        ]
      });
        window.addEventListener('resize', () => {
                // 自动渲染echarts
                this.echarts.resize();
            })
    },
  },
  mounted() {
    this.drawLine3();
    this.getbore()
    // this.getcity()
    // this.getmodul()
    // this.gettarget()
    this.getData()
  },
  created() {
    this.$root.Bus.$off('target_id');
    this.$root.Bus.$off('city_id');
    this.$root.Bus.$on("city_id",value=>{
      this.year_data=[]
      this.x_zhexian=[]
      this.x_zhu=[]
      this.city_id=value
      this.getData()
    })
    this.$root.Bus.$on("target_id",value=>{
      this.year_data=[]
      this.x_zhexian=[]
      this.x_zhu=[]
      this.target_id=value
      this.getData(value)
    })
  },
};
</script>

<style scoped>
.home_bg {
  width: 100%;
  height: 100%;
  /* background: url("../../assets/img/back.jpg") no-repeat; */
}

.title {
  height: 100%;
  font-size: 30px;
  color: #0f215d;
  margin: auto;
  line-height: 837px;
  text-align: center;
}
.echarts {
  display: flex;
  justify-content: center;
}
/* .echarts1{
    width: 1000px;
    height: 1000px;
} */
.tooltip {
  border-radius: 4px;
  box-shadow: 2px 4px 6px 6px rgba(0, 0, 0, 0.2);
  background: #fff;
}

.tooltip-title {
  padding: 0 5px;
  width: 170px;
  height: 30px;
  line-height: 30px;
  border-bottom: 1px solid #ebf0f5;
  color: #333;
}

.tooltip-content {
  padding: 5px 10px;
  min-height: 50px;
}

.tooltip-title-right {
  float: right;
  padding-right: 10px;
  font-size: 16px;
  color: #30a8e7;
}

.tooltip-title-left {
  padding-left: 10px;
  color: #333;
}
</style>





// WEBPACK FOOTER //
// src/views/home/mouth_ct.vue